export default __webpack_public_path__ + "static/media/000_intro_part2.c5e8a854.mp4";